<template>
  <v-container>
    <v-dialog v-if="dialog" v-model="dialog" max-width="900px">
      <v-form v-model="valid" ref="formData">
        <v-card class="pt-3">
          <v-card-title>
           <span class="headline ml-2">{{ isEdit ? $t('edit') : $t('add') }}  {{$t('period')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('period_code')"
                    placeholder="Jan-2021"
                    v-model="dataItem.periodCode"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                    class="sae-required"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                   :label="$t('period_name')"
                    v-model="dataItem.periodName"
                    :rules="[...rules6, validator.alfaNumberNotRequired]"
                    class="sae-required"
                    required
                    counter
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" v-if="false">
                  <span class="sae-required">
                    <label for="type">{{$t('period_type')}}</label>
                  </span>
                  <v-radio-group v-model="dataItem.periodType" row :rules="rules2" disabled>
                    <v-radio :value="1" :label="$t('payroll')"></v-radio>
                    <v-radio :value="2" label="Bonus"></v-radio>
                    <v-radio :value="3" label="THR"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <label>{{$t('payroll_period')}}</label>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu_start"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(dataItem.startDate)"
                        :label="$t('start_date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataItem.startDate"
                      @change="onStartDateChange"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu_end"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(dataItem.endDate)"
                        :label="$t('end_date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="dataItem.startDate"
                      v-model="dataItem.endDate"
                      @change="onEndDateChange"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <label>{{$t('attendance_period')}}</label>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu_start2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(dataItem.attendanceStartDate)"
                        :label="$t('start_date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataItem.attendanceStartDate"
                      @change="onStartDateChange2"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu_end2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(dataItem.attendanceEndDdate)"
                        :label="$t('end_date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="dataItem.attendanceStartDate"
                      v-model="dataItem.attendanceEndDdate"
                      @change="onEndDateChange2"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="6" v-if="false">
                  <v-menu
                    ref="menu"
                    v-model="menu_payment"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(dataItem.paymentDate)"
                       :label="$t('payment_date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataItem.paymentDate"
                      @change="onMenuPaymentChange"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" v-if="false">
                  <v-menu
                    ref="menu"
                    v-model="menu_cutoff"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(dataItem.cutOfffDate)"
                        :label="$t('cutoff_date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :max="paymentDateMin"
                      v-model="dataItem.cutOfffDate"
                      @change="onMenuCutoffChange"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field :label="$t('note')" v-model="dataItem.note"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="saveOrUpdate(dataItem)"
                :disabled="!valid"
              >{{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{$t('delete_period')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteComponent(dataItem)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h2 class="mt-5 mb-6">{{$t('period_settings')}}</h2>

    <v-card class="px-6 pb-0 mb-3">
      <v-card-text class="pt-4 pb-5">
        <v-row align="center" justify="center">
          <v-col md="6" class="pt-0 pb-1">
            <v-btn right color="primary" @click="addItem">{{$t('add_period')}}</v-btn>
          </v-col>
          <v-col class="pt-0 pb-2">
            <v-text-field
              :rules="[validator.alfaNumberNotRequired]"
             :label="$t('search')"
              prepend-inner-icon="mdi-magnify"
              single-line
              v-model="search"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-data-table
        :search="search"
        :items="dataList"
        :headers="headers"
        :no-data-text="$t('no_data')"
        class="elevation-1 mt-3"
        :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" 
      >
       <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
        <template v-slot:item.no="{ index }">{{index+1}}</template>
        <template v-slot:item.periodType="{ item }">{{getPeriodType(item.periodType)}}</template>
        <template v-slot:item.action="{ item }">
          <span>
            <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
            <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: "Period",
  data() {
    return {
      paymentDateMin: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      activeOnly: false,
      isEdit: false,
      deleteScheduleTime: false,
      dialog: false,
      deleteDialog: false,
      typeComponent: [],
      dataList: [],
      taxList: [],
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('period'), value: "periodName" },
        { text: this.$i18n.t('type'), value: "periodType" },
        { text: this.$i18n.t('pay_date'), value: "paymentDate" },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      dataItem: {
        id: 0,
      },
      search: "",
      editedIndex: -1,
      valid: true,
      rules: [(v) => !!v || this.$i18n.t('required')],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules3: [(v) => !!v || this.$i18n.t('required'), (v) => (v ? v.length <= 5 : false) || 'Max 5 Char'],
      rules6: [(v) => !!v || this.$i18n.t('required'), (v) => (v ? v.length <= 50 : false) || 'Max 50 Char'],
      loading: false,

      menu_start: false,
      menu_start2: false,
      menu_end: false,
      menu_end2: false,
      menu_cutoff: false,
      menu_payment: false,

    };
  },
  methods: {
    onStartDateChange() {
      const diff = moment(this.dataItem.endDate).locale(this.$i18n.t('lang')).diff(this.dataItem.startDate, 'days')
      if (diff < 0) this.dataItem.endDate = this.dataItem.startDate
      this.menu_start = false;
    },
    onEndDateChange() {
      this.menu_end = false;
    },
    onStartDateChange2() {
      const diff = moment(this.dataItem.attendanceEndDdate).locale(this.$i18n.t('lang')).diff(this.dataItem.attendanceStartDate, 'days')
      if (diff < 0) this.dataItem.attendanceEndDdate = this.dataItem.attendanceStartDate
      this.menu_start2 = false;
    },
    onEndDateChange2() {
      this.menu_end2 = false;
    },
    onMenuCutoffChange() {
      this.menu_cutoff = false
    },
    onMenuPaymentChange(event) {
      this.paymentDateMin = moment(event).locale(this.$i18n.t('lang')).subtract(1, 'day').format('YYYY-MM-DD')
      this.dataItem.cutOfffDate = this.paymentDateMin
      this.menu_payment = false
    },
    dateFormatted(date) {
      if (date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      } else {
        return ''
      }
    },
    getPeriodType(type) {
      switch (type) {
        case 1: return 'Payroll'
        case 2: return 'Bonus'
        case 3: return 'THR'
      }
    },
    costumHeader(action, actionId) {
      return { headers: { action, actionId } }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async getPeriod() {
      return await this.$store.dispatch('getPeriod')
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = {
        ...data,
        periodMonth: moment(data.endDate).locale(this.$i18n.t('lang')).format('MM'),
        periodYear: moment(data.endDate).locale(this.$i18n.t('lang')).format('YYYY'),
      }
      this.loading = true
      const result = await this.$store.dispatch('savePeriod', body)
      this.loading = false
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataList = await this.getPeriod()
        this.dataItem = {}
      }
    },
    async editComponent(data) {
      const body = {
        ...data,
        periodMonth: moment(data.endDate).locale(this.$i18n.t('lang')).format('MM'),
        periodYear: moment(data.endDate).locale(this.$i18n.t('lang')).format('YYYY'),
      }
      this.loading = true
      const result = await this.$store.dispatch('editPeriod', body)
      this.isEdit = false
      this.loading = false
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataList = await this.getPeriod()
        this.dataItem = {}
      }
    },
    async deleteComponent(data) {
      this.loading = true
      const result = await this.$store.dispatch('deletePeriod', data)
      this.loading = false
      if (result == true) {
        this.showMessage('success', 'Data Deleted')
        this.deleteDialog = false
        this.dataList = await this.getPeriod()
      }
    },
    addItem() {
      this.dataItem = Object.assign({
        periodType: 1,
        startDate: null,
        endDate: null,
        attendanceStartDate: null,
        attendanceEndDdate: null,
        paymentDate: null,
        cutOfffDate: null,
      });
      this.isEdit = false
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    editedItem(item) {
      this.isEdit = true
      this.dataItem = Object.assign({}, item);
      this.dataItem.type = item.typeId
      this.dialog = true
    },
    deleteItem(item) {
      this.dataItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async refreshData() {
      this.dataList = await this.getPeriod()
    }
  },
  async created() {
    this.dataList = await this.getPeriod()
    this.dataItem = {
      // startDate: moment().format('YYYY-MM-DD'),
      // endDate: moment().format('YYYY-MM-DD'),
      // attendanceStartDate: moment().format('YYYY-MM-DD'),
      // attendanceEndDdate: moment().format('YYYY-MM-DD'),
      // paymentDate: moment().format('YYYY-MM-DD'),
      // cutOfffDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    }
  },
  watch: {
    dialog(show) {
      if (!show) {
        setTimeout(() => {
          if (this.$refs.formData) {
            this.$refs.formData.reset();
            this.dataItem = {
              id: 0,
              // startDate: moment().format('YYYY-MM-DD'),
              // endDate: moment().format('YYYY-MM-DD'),
              // attendanceStartDate: moment().format('YYYY-MM-DD'),
              // attendanceEndDdate: moment().format('YYYY-MM-DD'),
              // paymentDate: moment().format('YYYY-MM-DD'),
              // cutOfffDate: moment().format('YYYY-MM-DD'),
            }
          }
        }, 300);
      }
    },
  },
};
</script>
